// Gating de features por grupo de testeo (`company_profiles.grupo_testing`).
//
// Modelo:
//  · El estudio es UNO solo para todos: `/interfaz-v2` (Interfaz V2 + Modos). El flujo
//    clásico (Estudio Virtual → seleccionar productos), que era el del Grupo A y el de
//    las cuentas con grupo desconocido, se borró en ADR-2026-10-28-se-borra-el-flujo-clasico.
//    Decidir por grupo era el bug: un grupo todavía desconocido (primer login sin cache,
//    alta recién creada) mandaba a clientes B y C a la pantalla vieja.
//  · grupo_testing 'C' → además la INTERFAZ NUEVA de escritorio: la home por destino y la
//    sidebar por secciones (ADR-2026-10-07-grupo-c-ve-la-interfaz-nueva).
//    Desde el 2026-10-17 toda alta nueva nace en C (ADR-2026-10-17-las-altas-nuevas-nacen-en-c);
//    las cuentas que ya existían siguen en su grupo.

/** Grupo C: la interfaz nueva. El onboarding del backend lo escribe en cada alta desde el
 *  2026-10-17; a una cuenta vieja se la pasa a mano (`UPDATE company_profiles`). */
export const GRUPO_C = "C";

/**
 * La home por destino y la sidebar por secciones (ADR-2026-10-07-grupo-c-ve-la-interfaz-nueva).
 * Desconocido (`null`, fallo de red, primer login) → `false`: la UI de siempre. No mira
 * `dev_tester` a propósito: los testers entran a C por la columna, como cualquier cuenta.
 */
export function usaInterfazNueva(grupo: string | null | undefined): boolean {
  return grupo === GRUPO_C;
}

/** El estudio: la home de todos. */
export const V2_STUDIO_PATH = "/interfaz-v2";
